import React from "react";
import PartyList from "./PartyList";

export default function BuyerList() {
  return <PartyList type="buyer" />;
}
